import { inject } from '@angular/core';
import { CanActivateFn, Router} from '@angular/router';
import { ServiceService } from './Service/service.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(ServiceService);
  const router = inject(Router);

  if (state.url === '/timeout') {
    return true;
  }

  // 👇 Skip redirect for PasswordChangeRequest
  if (!authService.getToken() && !state.url.includes('/PasswordChangeRequest')) {
    return router.parseUrl('/login-page');
  }

  return true;
};
